import gql from 'graphql-tag';
import {get, isEmpty} from 'lodash';
import {useQuery} from '@apollo/react-hooks';
import {VrboPriceSummaryFragments} from '@homeaway/react-price-summary';

const POPULAR_FILTER_ID = '13';
const amenityCarouselSearchQuery = gql`
    query amenityCarouselSearchQuery(
        $request: SearchResultRequest!
        $popularFilters: [String]!
    ) {
        popularAmenitySearch(
            request: $request
            popularFilters: $popularFilters
        ) {
            searchResult {
                listings {
                    averageRating
                    bedrooms
                    detailPageUrl
                    listingId
                    propertyMetadata {
                        headline
                    }
                    headlinePhoto(treatment: C4) {
                        uri
                    }
                    photos(treatment: C4) {
                        uri
                    }
                    sleeps
                    averagePrice {
                        value
                    }
                    priceSummary {
                        formattedAmount
                        pricePeriodDescription
                    }
                    prices {
                        ...VrboTravelerPriceSummary
                    }
                    spaces {
                        bathrooms {
                            capacity
                        }
                    }
                    reviewCount
                }
            }
            title
            chosenFilter
        }
    }
    ${VrboPriceSummaryFragments.VrboPriceSummary}
`;

export const useFetchAmenityCarouselListings = (
    searchParams,
    isMobile,
    parsedParams,
    results,
    skipQuery
) => {
    const popularFilters = results.filterGroups.find(
        (item) => item.groupInfo.id === POPULAR_FILTER_ID
    ) || {filters: []};

    const {data, loading} = useQuery(amenityCarouselSearchQuery, {
        skip: skipQuery,
        errorPolicy: 'ignore',
        variables: {
            request: {
                ...parsedParams,
                paging: {
                    page: 1,
                    pageSize: 10
                }
            },
            popularFilters: popularFilters.filters.reduce(
                (acc, value) => [...acc, value.filter.refineByQueryArgument],
                []
            )
        }
    });

    const listings = get(
        data,
        ['popularAmenitySearch', 'searchResult', 'listings'],
        []
    );

    return {
        amenityCarouselData: isEmpty(listings) ? null : data,
        amenityCarouselDataLoading: loading
    };
};
